import { useTheme } from "@mui/material";

type KendoReactColoredFooterCellProps = {
  cellText?: string;
};

export const KendoReactColoredFooterCell = ({ cellText }: KendoReactColoredFooterCellProps) => {
  const theme = useTheme();
  return <td style={{ backgroundColor: theme.palette.grey[colorShade] }}>{cellText}</td>;
};

export const colorShade = "400";
